import dayjs from "dayjs";
import { useCallback, useRef } from "react";
import CryptoJS from 'crypto-js'
import { fareUpdateLimitObj } from "../components/Booking/constant";

export const focusElemnt = (elementID) => {
  elementID &&
    document.getElementById(elementID) &&
    document.getElementById(elementID).focus();
};

export const navigationWithArrow = (e, nextId, prevId, clickFunction) => {
  if (e.key === "Escape" || e.key === 'ArrowLeft') {
    e.stopPropagation()
    focusElemnt(prevId);
  } else if (e.key === "ArrowRight") {
    e.stopPropagation()
    focusElemnt(nextId);
  } else if (e.key === "Enter") {
    e.stopPropagation()
    e.preventDefault()
    clickFunction();
  }
};
export const navigation1 = (e, nextId, prevId) => {

  if (e.key === "Escape") {
    e.stopPropagation()
    focusElemnt(prevId);
  }
  if (e.key === "Enter") {
    e.stopPropagation()
    focusElemnt(nextId);
    e.preventDefault();
  }
};

export const navigation3 = (e, nextId, prevId, clickFunction) => {
  if (e.key === "Escape") {
    e.stopPropagation()
    focusElemnt(prevId);
  }
  if (e.key === "Enter") {
    e.preventDefault();
    focusElemnt(nextId);
  }
  if (e.keyCode === 32) {
    e.preventDefault();
    clickFunction();
  }
};


export const checkAndFocus = (id) => {
  const elem = document.getElementById(id);
  if (elem) {
    focusElemnt(id)
  } else {
    requestAnimationFrame(() => {
      checkAndFocus(id)
    });
  }
};
export const formatDate1 = (value) => {

  const formattedDate = dayjs(value).format('YYYY-MM-DD');

  return formattedDate;
}

export const isEmpty = (obj) => {
  return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype
}



export const getSurroundingDates = (
  currentDate = new Date(),
  pastDays = 4,
  futureDays = 5
) => {
  const baseDate = dayjs(currentDate).startOf('day');
  const today = dayjs().startOf('day');

  const totalCount = pastDays + futureDays + 1;
  const dates = [];

  let cursor = baseDate.subtract(pastDays, 'day');

  while (dates.length < totalCount) {
    if (!cursor.isBefore(today)) {
      dates.push(cursor.toDate());
    }
    cursor = cursor.add(1, 'day');
  }

  return dates;
};




export const createOldChartData = (chartData = []) => {
  let colNameList = {}
  let groupByRow = {}
  let bookSeat = 0
  let bookSeatPhone = 0
  let available = 0

  chartData.forEach((obj) => {
    if (obj.IsBkgAvailable === 0) {
      if (obj.BookingType === 'C') {
        bookSeatPhone += 1
      } else {
        bookSeat += 1
      }
    }
    if (obj.IsBkgAvailable === 1 && !obj.IsAisle) {
      available += 1
    }
    if (!colNameList?.[obj.ColumnNo]) {
      colNameList[obj.ColumnNo] = { ColumnNo: obj.ColumnNo, deck: obj.Deck === 1 ? 'Dn' : 'Up', }
    }

    if (!groupByRow?.[obj.RowNo]) {
      groupByRow[obj.RowNo] = [obj]
    } else {
      let newRowData = [...groupByRow[obj.RowNo], obj]
      groupByRow[obj.RowNo] = newRowData?.sort((a, b) => a.ColumnNo - b.ColumnNo)
    }
  })

  const seatSort = Object.fromEntries(
    Object.entries(groupByRow)
      .sort(([keyA], [keyB]) => Number(keyA) - Number(keyB)) // sort outer keys
      .map(([key, arr]) => [
        key,
        arr.sort((a, b) => a.column - b.column) // sort each array by column
      ])
  );
  let sortChartLabel = Object.keys(colNameList).map((key) => colNameList[key]).sort((a, b) => a.ColumnNo - b.ColumnNo)
  return {
    lableList: sortChartLabel,
    seatRowData: seatSort,
    bookSeat,
    available,
    bookSeatPhone,
  }
}

export const useDebouncedHandler = (callback, delay = 500) => {
  const timer = useRef(null);

  return useCallback((...args) => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      callback(...args);
    }, delay);
  }, [callback, delay]);
};

export const formatDecimal = (num, place = 2) => {
  if (num % 1 !== 0) {
    return Number(num.toFixed(place));
  }
  return Number(num);
};


export const checkEmailValid = (val) => {
  if (val.length) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test(val);
  }
  else
    return true;
}

export const transferArrToObjectWIthCaret = (arr) => {
  const newObject = arr.reduce((result, obj) => {
    Object.keys(obj).forEach(key => {
      result[key] = result[key] ? `${result[key]}^${obj[key]}` : `${obj[key]}`;
    });
    return result;
  }, {});
  return newObject
}

export const transferArrToObject = (arr) => {
  const newObject = arr.reduce((result, obj) => {
    Object.keys(obj).forEach(key => {
      result[key] = result[key] ? `${result[key]},${obj[key]}` : `${obj[key]}`;
    });
    return result;
  }, {});
  return newObject
}

export const generateChecksum = (requestBody, saltKey = 'salt-secret') => {
  // Sort alphabetical keys of create order request body JSON and construct string
  const sortedKeys = Object.keys(requestBody).sort();
  const checksumString = sortedKeys
    .filter(key => key !== 'checksum' && !(key === 'transferfee' && requestBody[key] === 0)) // Exclude 'checksum' key if present & transferFee if its value is 0
    .map(key => `${key.toLowerCase()}:${requestBody[key]}`) // Use backticks for template literals
    .join('|');

  // Append salt key
  const checksumStringWithSalt = `${checksumString}|${saltKey}`; // Use backticks for template literals

  // Use SHA256 encryption to generate checksum digest
  const checksumDigest = CryptoJS.SHA256(checksumStringWithSalt).toString();
  return checksumDigest;
}
export const NumberFormatter = (value, decimal) => {
  if (Number.isInteger(value)) {
    return parseFloat(parseFloat(value).toFixed(0)).toLocaleString(
      "en-IN",
      {
        useGrouping: true,
        minimumFractionDigits: 0
      }
    );
  }
  else {
    return parseFloat(parseFloat(value).toFixed(decimal || 2)).toLocaleString(
      "en-IN",
      {
        useGrouping: true,
        minimumFractionDigits: decimal || 2
      }
    );
  }
};

export const formatBookingListData = (arr = []) => {
  return (arr.map((item) => {
    return {
      ...item,
      BookingDate: item?.BookingDate ? dayjs(item?.BookingDate).format('DD-MM-YYYY HH:mm') : '',
      JourneyDate: item?.JourneyDate ? dayjs(item?.JourneyDate).format('DD-MM-YYYY HH:mm') : '',
      TotalFare: item?.TotalFare ? NumberFormatter(item?.TotalFare, 2) : '0.00',
      RefundAmount: item?.RefundAmount ? NumberFormatter(item?.RefundAmount, 2) : '0.00',
      BookingType: item?.BookingType === "AC" ? "Confirm" : item?.BookingType === "AP" ? 'Phone' : '',
      BookingStatus: item?.BookingStatus === "C" ? "Cancelled" : item?.BookingStatus === "B" ? 'Booked' : '',
    }
  })).sort((a, b) => dayjs(b.BookingDate).toDate() - dayjs(a.BookingDate).toDate())
}


export const generateCommission = (tripTotalAmt = {}, bkgDeatails = {}, transferfee = 0) => {
  let amount = tripTotalAmt.grandAmt || 0
  if (Number(bkgDeatails?.CommissionPer || 0) > 0) {
    amount -= (Number(tripTotalAmt.baseFare) * Number(bkgDeatails?.CommissionPer || 0)) / 100
  } else {
    let CommseatAmt = 0
    let CommslprAmt = 0
    CommseatAmt = Number(bkgDeatails.CommseatAmt || 0);
    CommslprAmt = Number(bkgDeatails.CommslprAmt || 0);
    let SleeperCount = tripTotalAmt?.sleeperCount
    let SeatCount = tripTotalAmt?.seaterCount
    if (SleeperCount >= 1 && SeatCount >= 1) {
      amount -= (CommseatAmt * SeatCount) + (CommslprAmt * SleeperCount);
    }
    else if (SleeperCount >= 1 && SeatCount === 0) {
      amount -= Number(bkgDeatails.CommissionAmt || 0) * SleeperCount;
    }
    else if (SeatCount >= 1 && SleeperCount === 0) {
      amount -= Number(bkgDeatails.CommissionAmt || 0) * SeatCount;
    }
  }
  amount = Math.round(amount);
  return amount
}

export const initializeInactivityTimer = (handleLogout, time) => {
  let inactivityTimeout;
  const logoutTime = time * 60 * 1000;
  const logout = () => {
    if (JSON.parse(sessionStorage.getItem("userDetails"))) {
      handleLogout(true);
      clearTimeout(inactivityTimeout);
    }
  };

  const resetTimer = () => {
    clearTimeout(inactivityTimeout);
    inactivityTimeout = setTimeout(logout, logoutTime);
  };

  const events = ["mousemove", "keypress"];
  events.forEach((event) => window.addEventListener(event, resetTimer));

  resetTimer();

  return () => {
    events.forEach((event) => window.removeEventListener(event, resetTimer));
    clearTimeout(inactivityTimeout);
  };
};

export const getTextColor = (bg) => {
  try {
    if (!bg) return "#fff";

    const [r, g, b] = bg.split(",").map(Number);

    if ([r, g, b].some((val) => isNaN(val))) {
      return "#fff";
    }

    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    return brightness > 128 ? "#000" : "#fff";
  } catch (e) {
    return "#fff";
  }
};


export const shortcutKey = (event) => {
  if (!event.altKey) return;

  switch (event.key.toLowerCase()) {
    case "a":
      event.preventDefault();
      focusElemnt("fromCity");
      break;

    case "t":
      event.preventDefault();
      focusElemnt("toCity");
      break;

    // case "s":
    //   event.preventDefault();
    //   focusElemnt("Save");
    //   break;

    default:
      break;
  }
};

export const gstIconStatusData = (arr = []) => {
  let showGpsIcons = false
  let gspData = {}
  if (arr?.length === 0) {
    return { showGpsIcons, gspData }
  }
  gspData = { ...(arr?.[0] || {}) }
  if (gspData?.Status !== null) {
    if ((gspData?.Status.toLowerCase().indexOf('show') > -1 || gspData?.Status.toLowerCase().indexOf("breakdown") > -1) && Number(gspData?.IsIncessant) === 1) {
      if ((gspData?.GPSVehicleID !== undefined && gspData?.GPSVehicleID?.toString()?.trim() !== '') && (gspData?.busnumber !== undefined && gspData?.busnumber?.toString()?.trim() !== '')) {
        showGpsIcons = true
      }
    }
  }
  return { showGpsIcons, gspData }
}
export const isCheckFareLimit = (bkgDeatails, fieldName, value) => {
  let limitOnFareChange = bkgDeatails?.limitOnFareChange || 0
  let limitOnFareChangePer = bkgDeatails?.limitOnFareChangePer || 0
  let tripDetails = bkgDeatails?.tripDetails

  let changeAmtLimit = 0
  if (limitOnFareChangePer > 0) {
    changeAmtLimit = Number(tripDetails?.[fareUpdateLimitObj?.[fieldName]]) - Math.round((Number(tripDetails?.[fareUpdateLimitObj?.[fieldName]]) * limitOnFareChangePer) / 100)
  } else {
    changeAmtLimit = Number(tripDetails?.[fareUpdateLimitObj?.[fieldName]]) - limitOnFareChange

  }
  if (value < changeAmtLimit) {
    return true
  }
  return false
}



export const isCheckSeatFareLimit = (bkgDeatails, orgSeatFare = 0, value) => {
  let limitOnFareChange = bkgDeatails?.limitOnFareChange || 0
  let limitOnFareChangePer = bkgDeatails?.limitOnFareChangePer || 0

  let changeAmtLimit = 0
  if (limitOnFareChangePer > 0) {
    changeAmtLimit = Number(orgSeatFare) - Math.round((Number(orgSeatFare) * limitOnFareChangePer) / 100)
  } else {
    changeAmtLimit = Number(orgSeatFare) - limitOnFareChange

  }
  if (value < changeAmtLimit) {
    return true
  }
  return false
}
